export default __webpack_public_path__ + "static/media/logo.3ca726a1.png";